// extracted by css-extract-rspack-plugin
export default {"linkContainer":"_50eec1ec","large":"_4c79bdf6","imageContainer":"_b7dd1f8b","title":"_4f23afcb","small":"_3d0a2094","image":"_b01f21ac"};